(ns hai.entity.data
  "Web-app events shared by every entity surface."
  (:require
   [hai.ui.rf-sugar :refer [>e defevent-fx]]
   [hai.web-app.routing :as routing]))

;; Every route takes the entity map itself, the way the omnibar's search
;; results do — routed by the id attr the chip's entity carries.
(defn- detail-route
  [entity]
  (cond
    (:contact/uuid entity) [:contacts/detail entity]
    (:task/uuid entity)    [:tasks/detail entity]
    (:space/uuid entity)   [:spaces/detail entity]
    :else                  [:notes/detail entity]))

;; Clicking a linked contact/note/task chip goes to that entity's own page.
(defevent-fx ::open-entity [_ entity]
  {:dispatch [:routing/navigate (detail-route entity)]})

(defn open-entity
  "The standard `:on-open-entity` handler — every web-app surface routes chips
   the same way; a surface without routing (the extension sidebar) omits the
   prop instead."
  [entity]
  (>e [::open-entity entity]))

(defn open-entity-in-new-tab
  "An `:on-open-entity` handler for a surface that should stay as it is: the
   entity's own page opens in a new tab. Opened in the click itself, which a
   browser's pop-up blocker lets through."
  [entity]
  (js/window.open (apply routing/href (detail-route entity)) "_blank" "noopener,noreferrer"))
